import { Modal } from "antd";

const DEFAULT_MESSAGE =
  "You have unsaved changes. Are you sure you want to leave? Your changes will be lost.";

export const confirmLeaveNavigation = (
  message: string = DEFAULT_MESSAGE
): Promise<boolean> =>
  new Promise((resolve) => {
    Modal.confirm({
      title: "Unsaved changes",
      content: message,
      okText: "Leave",
      okType: "danger",
      cancelText: "Stay",
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
